import { NotificationBase } from 'src/app/shared/services/notification/notification-base';

export class NotificationAgreementRequest extends NotificationBase {
  process() {
    if (!this.isCurrentPage()) {
      this.handleAlert();
    }
  }

  viewNotification() {
    if (this.item.conversation_id) {
      this.navCtrl.navigateForward(`/agreement/create/${this.item.conversation_id}`);
    } else {
      console.error('[Agreement Request Push Notification] No conversation_id', this.item);
      this.navCtrl.navigateForward('/tabs/manage-clients?tab=agreements');
    }
  }

  private handleAlert(): void {
    this.showAlert();
  }

  /**
   * Checks to see whether the current page matches the agreement creation page.
   *
   * @returns true if the current page is the agreement creation.
   */
  private isCurrentPage(): boolean {
    if (this.item.conversation_id) {
      return this.currentRoute() === `/agreement/create/${this.item.conversation_id}}`;
    }
    return false;
  }
}
